// extracted by mini-css-extract-plugin
export default {"btn":"RecentlyAddedBooksRow_btn__vB+Gc","tr":"RecentlyAddedBooksRow_tr__IsfEW"};